import React, { useState, useEffect, useContext } from 'react'
import { useJwt } from 'react-jwt'
import UserContext from '../contexts/UserContext'
import { UserProviderProps } from '../types/globalTypes'
import { validateTokenAndRedirect } from '../utils/tokenValidation'
import GlobalLoadingOverlay from '../components/GlobalLoadingOverlay'

const PrivateRoute: React.FC<UserProviderProps> = (props) => {
  const { token, setToken, setUser, isLoadingAuth } = useContext(UserContext)
  const { isExpired, decodedToken } = useJwt(token)
  const [statusValidate, setStatusValidate] = useState<boolean>(false)
  const [isValidating, setIsValidating] = useState<boolean>(true)

  useEffect(() => {
    if (!isLoadingAuth) {
      validateAccess()
    }
  }, [token, isExpired, isLoadingAuth])

  const validateAccess = () => {
    const isValid = validateTokenAndRedirect(token)

    if (!isValid) {
      setToken('')
      setUser({} as any)
      setIsValidating(false)
      return
    }

    setStatusValidate(true)
    setIsValidating(false)
  }

  if (isLoadingAuth || isValidating) {
    return <GlobalLoadingOverlay />
  }

  return <>{statusValidate ? props.children : <></>}</>
}

export default PrivateRoute
